<template>
  <transition-expand-height>
    <span v-show="!!showError" class="form-error">
      <span
        class="small form-error__error"
        v-html="lastError === true ? `Something went wrong` : lastError"
      />
    </span>
  </transition-expand-height>
</template>

<script>
// Vuex
import { mapGetters } from 'vuex';

// Utils
import { formatError } from 'utils/forms';
import phone from 'utils/phone';

// Transitions
import TransitionExpandHeight from 'components/ExpandHeight';

// Export
export default {
  name: 'module-error',

  // Components
  components: {
    TransitionExpandHeight,
  },

  // Props
  props: {
    id: {
      type: String,
      required: true,
      validator: value => value !== 'global',
    },
    field: {
      type: Object,
    },
    hide: {
      type: Boolean,
    },
  },

  // Data
  data() {
    return {
      lastError: '',
    };
  },
  computed: {
    ...mapGetters('forms', ['getFormServerError', 'getFieldServerError']),
    ...mapGetters('app', ['org']),
    showError() {
      return this.serverError ? true : this.hide ? false : this.fieldError;
    },

    serverError() {
      return this.field
        ? this.getFieldServerError(this.id)
        : this.getFormServerError(this.id);
    },
    fieldError() {
      const field = this.field;
      if (!field) return null;

      return !field.error
        ? null
        : formatError(field.error, {
          min: field.min,
          max: field.max,
        });
    },
  },
  watch: {
    fieldError(error) {
      this.setLastError(error);
    },
    serverError(error) {
      this.setLastError(error);
    },
  },

  // Methods
  methods: {
    setLastError(error) {
      // Catch unverified user server response

      error =
        error === 'User is not verified!'
          ? 'Please verify your account with your one-time password sent to your email address.'
          : error;

      error =
        error === 'User is not verified yet!'
          ? 'You still need to verify your account. Please retrieve your latest 6-digit verification code from your email.'
          : error;

      error =
        error === 'This user account exists on MDlive and can\'t be created.'
          ? `It looks like an account has already been created for you. Please log in above, or contact us for assistance at ${phone(
            this.org.phone
          )}.`
          : error;


      if (error && error.num_of_failed_login_attempts && error.num_of_failed_login_attempts > 2) {
        error = 'Your account was temporarily locked due to many unsuccessful login attempts. To unlock your account, please reset your password using the "Forgot?" option above.';
      } else if (error && error.error) {
        error = error.error;
      }

      if (error) this.lastError = error;
    },
  },

  // Lifecycle
  mounted() {
    this.setLastError(this.fieldError);
  },
};
</script>



// WEBPACK FOOTER //
// Error.vue?7e12db92